/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcribe_Unsupported_TypeInputs */

const en_us2_transcribe_unsupported_type = /** @type {(inputs: Transcribe_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This recording format isn't supported. Type your message instead.`)
};

const pt_br2_transcribe_unsupported_type = /** @type {(inputs: Transcribe_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse formato de gravação não é aceito. Digite a mensagem.`)
};

const es_419_transcribe_unsupported_type = /** @type {(inputs: Transcribe_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formato de grabación no es compatible. Escribe tu mensaje.`)
};

const pt_pt2_transcribe_unsupported_type = /** @type {(inputs: Transcribe_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse formato de gravação não é aceite. Escreve a mensagem.`)
};

const fr_fr2_transcribe_unsupported_type = /** @type {(inputs: Transcribe_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce format d'enregistrement n'est pas pris en charge. Écris plutôt ton message.`)
};

const de_de2_transcribe_unsupported_type = /** @type {(inputs: Transcribe_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Aufnahmeformat wird nicht unterstützt. Tippe deine Nachricht stattdessen.`)
};

const it_it2_transcribe_unsupported_type = /** @type {(inputs: Transcribe_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo formato di registrazione non è supportato. Scrivi il messaggio.`)
};

/**
* | output |
* | --- |
* | "This recording format isn't supported. Type your message instead." |
*
* @param {Transcribe_Unsupported_TypeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const transcribe_unsupported_type = /** @type {((inputs?: Transcribe_Unsupported_TypeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcribe_Unsupported_TypeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_transcribe_unsupported_type(inputs)
	if (locale === "es-419") return es_419_transcribe_unsupported_type(inputs)
	if (locale === "pt-PT") return pt_pt2_transcribe_unsupported_type(inputs)
	if (locale === "fr-FR") return fr_fr2_transcribe_unsupported_type(inputs)
	if (locale === "de-DE") return de_de2_transcribe_unsupported_type(inputs)
	if (locale === "it-IT") return it_it2_transcribe_unsupported_type(inputs)
	return en_us2_transcribe_unsupported_type(inputs)
});
export { transcribe_unsupported_type as "transcribe.unsupported_type" }